import React, { useState } from "react";

import StatusSummary from "./components/StatusSummary";
import SymbolAbbreviations from "./components/SymbolAbbreviations";
import RiskTriggerCard from "./components/RiskTriggerCard";


const CARDS_DATA = [
  {
    id: 1,
    severity: "Critical",
    title: "Cylinder Liner Wear Suspicion",
    date: "24/03/2026, 11:28:13",
    equipmentName: "ME CYLINDER LINERS",
    equipmentId: "39570",
    recommendedPort: "Busan",
    status: "NEW",
    summary: "Multiple cylinders on the MAN 5S50ME-B9.3 main engine are exhibiting high jacket cooling water outlet and exhaust gas temperatures, with oil analysis indicating abnormal wear (elevated iron) and low base number in several units. These findings, combined with overdue cylinder head, liner, and piston ring inspections, suggest risk of accelerated liner wear, piston ring failure, and potential cylinder damage. If ignored, this may lead to catastrophic engine failure, non-compliance with class/flag requirements, and costly downtime.",
    triggerCondition: "cyl_1_jacket_cooling_water_outlet_temp_high > 30 ∧ exhaust_gas...",
    telemetry: [
      { vesselTime: "2026-03-24 05:59:00", cyl1TempHigh: "84",   exhaustGas: "" },
      { vesselTime: "2026-03-24 05:58:00", cyl1TempHigh: "84.2", exhaustGas: "" },
    ],
    maintenanceIntelligence: "10 cylinder-related jobs are overdue, including cylinder head inspection, liner calibration, piston rod inspection, and cleaning. Next due dates range from 2025-10-22 to 2026-02-16. Job descriptions reference MAN PrimeServ service letters GS11-14, GS14-010, GS03-02, SK93-01, GS05-21, GS06-15, GS11-13A, GS11-13C. No recent completion records found.",
    recommendedAction: "Immediately review lubrication system for correct feed rate and oil quality. Conduct stepwise checks: 1) Inspect cylinder liner wear and calibration, 2) Examine piston rings for breakage or excessive clearance, 3) Assess cylinder head and exhaust valve for deposits and leakage, 4) Analyze scavenge drain oil for further wear metals and BN trends. Schedule cylinder immobilization and full inspection at Busan (ETA 2026-04-07). Reference MAN PrimeServ SL/TL letters for inspection criteria and ensure compliance with class/flag requirements for overdue maintenance. Urgent action required to prevent engine damage.",
    reportInsights: "Risk of accelerated liner and piston ring wear is high, with abnormal oil analysis and overdue maintenance exposing the vessel to class/flag non-compliance and potential engine failure. MAN 5S50ME-B9.3 engines are sensitive to lubrication and liner condition; ignoring these findings may result in costly repairs and operational delays. Immediate corrective action and compliance with manufacturer and class requirements are essential.",
    voyageRecommendation: "Schedule cylinder immobilization and maintenance at Busan, South Korea, ETA 2026-04-07 08:00:00. Ensure all spares and tools are prepared for full cylinder inspection and overhaul.",
  },
  {
    id: 2,
    severity: "Critical",
    title: "Main Engine Turbocharger Fault",
    date: "23/03/2026, 17:15:59",
    equipmentName: "ME TURBOCHARGER",
    equipmentId: "40120",
    recommendedPort: "Singapore",
    status: "NEW",
    summary: "Main engine turbocharger rpm has consistently exceeded 13000 RPM while scavenge inlet pressure remains above 11 bar. Fouling on the air path and restriction in the nozzle ring are suspected. If unaddressed, efficiency drift will worsen fuel consumption and may lead to compressor surge.",
    triggerCondition: "me_tc_rpm > 13000 ∧ scavenge_inlet_pressure > 11",
    telemetry: [
      { vesselTime: "2026-03-23 17:00:00", cyl1TempHigh: "13200", exhaustGas: "11.4" },
      { vesselTime: "2026-03-23 16:58:00", cyl1TempHigh: "13150", exhaustGas: "11.2" },
    ],
    maintenanceIntelligence: "Turbocharger water washing last completed 45 days ago. 3 overdue blower inspection jobs identified. Next dry cleaning due 2026-03-28.",
    recommendedAction: "1. Check PMS for related due jobs\n2. Give corrective action and steps to identify and fix this turbocharger issue\n3. Check voyage schedule for next maintenance window\n4. Analyze Oil reports for abnormalities",
    reportInsights: "Turbocharger efficiency loss is progressive. Fouling on the air path is the primary driver. Immediate water washing and inspection are recommended.",
    voyageRecommendation: "Schedule turbocharger maintenance at Singapore, ETA 2026-03-30. Arrange OEM specialist if nozzle ring replacement is required.",
  },
];

const STATUS_SUMMARY = {
  totalCards: 4,
  dueResponse: 3,
  accepted: 1,
  deferred: 0,
  rejected: 0,
  executed: 0,
  expired: 0,
  asOf: "14:10:23",
};

const RiskTriggerCards = () => {
  const [activeCardType, setActiveCardType] = useState("Risk Trigger Cards");
  const [search,         setSearch]         = useState("");
  const [statusFilter,   setStatusFilter]   = useState("All Action Status");

  const filtered = CARDS_DATA.filter(c =>
    !search || c.title.toLowerCase().includes(search.toLowerCase())
  );

  const cardTypes = ["Risk Trigger Cards", "Action Cards", "Voyage Cards"];

  return (
    <div style={{ display: "flex", gap: 14, padding: 16, background: "#f5f6f8", minHeight: "calc(100vh - 96px)", alignItems: "flex-start" }}>

      {/* ── Left main area ─────────────────────────────────────── */}
      <div style={{ flex: 1, minWidth: 0 }}>

        {/* Toolbar */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <div style={{ position: "relative" }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aab0be" strokeWidth="2"
              style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}>
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Search"
              style={{
                paddingLeft: 32, paddingRight: 12, height: 34, width: 200,
                border: "0.5px solid #e2e4e8", borderRadius: 6,
                fontSize: 12, color: "#1a1e2e", background: "#fff", outline: "none",
              }}
            />
          </div>
          <div style={{ position: "relative" }}>
            <select
              value={statusFilter} onChange={e => setStatusFilter(e.target.value)}
              style={{
                height: 34, padding: "0 32px 0 12px", border: "0.5px solid #e2e4e8",
                borderRadius: 6, fontSize: 12, color: "#1a1e2e",
                background: "#fff", appearance: "none", cursor: "pointer", outline: "none",
              }}
            >
              {["All Action Status", "NEW", "Accepted", "Deferred", "Rejected", "Executed", "Expired"].map(s => (
                <option key={s}>{s}</option>
              ))}
            </select>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8a909e" strokeWidth="2"
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>
        </div>

        {/* Card type tabs */}
        <div style={{
          display: "flex", gap: 2, marginBottom: 14,
          background: "#fff", border: "0.5px solid #e2e4e8",
          borderRadius: 8, padding: 4, width: "fit-content",
        }}>
          {cardTypes.map(type => (
            <button
              key={type}
              onClick={() => setActiveCardType(type)}
              style={{
                padding: "6px 16px", borderRadius: 6, border: "none", cursor: "pointer",
                fontSize: 12, fontWeight: 500,
                background: activeCardType === type ? "#1a9e78" : "transparent",
                color:      activeCardType === type ? "#fff"    : "#5a6070",
                display: "flex", alignItems: "center", gap: 6,
                transition: "all .15s",
              }}
            >
              {type === "Risk Trigger Cards" && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                </svg>
              )}
              {type === "Action Cards" && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                </svg>
              )}
              {type === "Voyage Cards" && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z"/>
                </svg>
              )}
              {type}
            </button>
          ))}
        </div>

        {/* Section header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1a9e78" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            </svg>
            <span style={{ fontSize: 14, fontWeight: 500, color: "#1a1e2e" }}>
              Risk Trigger Cards
            </span>
            <span style={{
              fontSize: 11, fontWeight: 500, padding: "1px 8px",
              borderRadius: 20, background: "#e1f5ee", color: "#0f6e56",
            }}>
              {filtered.length}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#8a909e" }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#8a909e" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Note: Defer/Reject requires a Reason before Submission. Accept requires a Comment about action taken and troubleshooting done.
          </div>
        </div>

        {filtered.map(card => (
          <RiskTriggerCard key={card.id} card={card} />
        ))}

        {filtered.length === 0 && (
          <div style={{ padding: 40, textAlign: "center", color: "#aab0be", fontSize: 13,
            background: "#fff", borderRadius: 10, border: "0.5px solid #e2e4e8" }}>
            No cards found
          </div>
        )}
      </div>

      {/* ── Right sidebar ───────────────────────────────────────── */}
      <div style={{ width: 200, flexShrink: 0, display: "flex", flexDirection: "column", gap: 14 }}>
        <StatusSummary data={STATUS_SUMMARY} />
        <SymbolAbbreviations />
      </div>
    </div>
  );
};

export default RiskTriggerCards;